/**
 * Created by mark on 6/24/2019.
 */
import Service from "../../AuthService";

const ChequeListPayoff = {
    getChequeListPayoff(page,sale_id) {
        return Service.get("/cheque-list-payoff?page="+page+"&sale_id="+sale_id);
    },
    showChequeListPayoff(id) {
        return Service.get("/cheque-list-payoff/" + id);
    },
    updateChequeListPayoff(id, data) {
        return Service.put("/cheque-list-payoff/" + id, data);
    },
    createChequeListPayoff(data) {
        return Service.post("/cheque-list-payoff", data);
    },
    deleteChequeListPayoff(id) {
        return Service.delete("/cheque-list-payoff/" + id);
    },
    searchChequeListPayoff(page,data){
        return Service.post('/cheque-list-payoff-search?page='+page,data);
    },
    selectAllChequeListPayoff(data){
        return Service.post('/select_all_cheque_payoff',data);
    },
    updateChequeStatus(data){
        return Service.post('/update-cheque-status',data);
    }
};

export default ChequeListPayoff
